import { createSelector } from '@reduxjs/toolkit';
import { SignalApi } from 'client/voladeum/signal/types';
import { RootState } from 'store';

const signalSlice = (state: RootState) => state.signal;

export const selectSignal = createSelector([signalSlice], (state): SignalApi => state);
